import {
    Radio, Checkbox, Typography, Icon, Stack, Paper, Box
} from '@mui/material'

import cls from 'classnames'

import Styles from './style'

export const Tile = (props) => {
    const variant = props.variant || 'primary'
    const controllerVariant = props.controllerVariant || 'primary'

    const rootSx = {
        ...Styles.variants[variant],
        ...(props.sx || {})
    }

    const onClick = () => {
        if (props.onClick) props.onClick()
    }

    const onChange = (id) => () => {
        if (props.onChange) props.onChange(id)
    }

    let controller = null
    if (props.checkbox) controller = props.checkbox
    if (props.radio) controller = props.radio

    return (
        <Paper
            id={props.id}
            sx={rootSx}
            elevation={props.elevation ?? 0}
            onClick={onClick}
            className={cls(
                (props.onClick) ? 'Tile-clickable' : '',
                (
                    (props.checkbox && controller?.selected)
                    || (props.radio && controller?.selected)
                ) ? 'Tile-checked' : ''
            )}
        >
            <Stack spacing={1} direction={'row'} justifyContent={'space-between'} alignItems={'center'} sx={(props.label && !props.noValueMb) ? {mb: 2} : {}}>
                {props.label && (<Typography sx={props.labelSx || {}} className={'Tile-label'} component={'div'}>{props.label}</Typography>)}
                {(props.radio || props.checkbox || props.icon || props.value || props.img || props.actions) && (
                    <Stack>
                        {props.radio && (
                            <Radio
                                id={controller.id}
                                icon={<Icon>{controller.icon || 'circle'}</Icon>}
                                checkedIcon={<Icon sx={{fontVariationSettings: "'FILL' 1"}}>{controller.checkedIcon || 'trip_origin'}</Icon>}
                                disabled={controller.disabled || false}
                                checked={controller.selected || false}
                                onChange={onChange(controller.id)}
                                value={controller.id}
                                variant={controllerVariant}
                            />
                        )}
                        {props.checkbox && (
                            <Checkbox
                                id={controller.id}
                                icon={<Icon>{controller?.icon || 'check_box_outline_blank'}</Icon>}
                                checkedIcon={<Icon sx={{fontVariationSettings: "'FILL' 1"}}>{controller?.checkedIcon || 'check_box'}</Icon>}
                                disabled={controller?.disabled || false}
                                checked={controller?.selected || false}
                                onClick={onChange(controller.id)}
                                variant={controllerVariant}
                            />
                        )}
                        {props.icon && (
                            <Icon sx={{fontSize: '30px'}}>{props.icon}</Icon>
                        )}
                        {props.value && (
                            <Typography variant={props.valueVariant || 'h5'} sx={props.sxValue || {}} style={Styles.valueColor[props.valueColor || 'default']}>{props.value}</Typography>
                        )}
                        {props.img && (
                            <img src={props.img} alt={props.imgAlt || 'imgAlt'} style={props.imgSx || {}}/>
                        )}
                        {props.actions && (props.actions)}
                    </Stack>
                )}
            </Stack>

            {props.sublabel && (<Typography sx={props.sublabel || {}} className={'Tile-sublabel'}>{props.sublabel}</Typography>)}
            {props.children && (
                <Box sx={props.childrenSx || {}} className={(props.label) ? 'Tile-children' : 'Tile-children-noMargin'}>
                    {props.children}
                </Box>
            )}
        </Paper>
    )
}

export default Tile